import React, { useState, useEffect } from 'react'
import { Row, Col, Card, Button, Modal, Form } from 'react-bootstrap';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { pythonAxiosInstance } from '../../config/ConfigInfo';
import { getItem, removeSetItem, setItem } from '../../config/localStorage';
import SpinLoader from '../../component/loader/SpinLoader';

function AccomplishmentsModal(props) {
    const jobTitle = getItem('jobTitle');
    const saveAccomplishmentEditorItem = getItem('accomplishmentsData');
    const checkAccomplishmentEditorList = saveAccomplishmentEditorItem ? saveAccomplishmentEditorItem.split('</p>') : '';

    const [accomplishmentEditorItem, setAccomplishmentEditorItem] = useState(saveAccomplishmentEditorItem ? saveAccomplishmentEditorItem :  '');
    const [accomplishmentList, setAccomplishmentList] = useState([]);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [accomplishmentValidation, setAccomplishmentValidation] = useState('');
    const [searchToggle, setSearchToggle] = useState(false);
    const [searchInput, setSearchInput] = useState('');
    const [loader, setLoader] = useState(true);

    let saveAccomplishmentList;
    if (saveAccomplishmentEditorItem) {
        function removeHtmlTags(str) {
            return str.replace(/<\/?[^>]+(>|$)/g, "");
        }
        saveAccomplishmentList = checkAccomplishmentEditorList.filter(item => item.trim() !== "").map(removeHtmlTags);
    }

    /** search functionality start */

    const handleAccomplishmentSearch = (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        setAccomplishmentValidation('');
        if (e.target.elements.searchAccomplishment.value === '') {
            setError('Please enter a job title');
        } else {
            setSearchToggle(!searchToggle);
            setSearchInput(e.target.elements.searchAccomplishment.value);
        }
    };

    /** search functionality end */

    const saveAccomplishment = () => {
        setAccomplishmentValidation('');
        setSuccess('');
        setError('');   
        if (accomplishmentEditorItem === '') {
            setAccomplishmentValidation('Please enter the accomplishment');
            removeSetItem('accomplishmentsData');
        } else {
            setItem('accomplishmentsData', accomplishmentEditorItem);
            setSuccess('Thank you for providing your accomplishment details.');
        }
    }

    /** call API to fetch the Accomplishment data start */

    useEffect(() => {

        (async () => {
            const raw = {
                job_title: searchInput === '' ? jobTitle : searchInput
            };
            try {
                setLoader(true);
                const response = await pythonAxiosInstance.post('generate-accomplishments-based-jobtitle/', raw);
                if (response.data.accomplishments) {
                    let updatedAccomplishment;
                    if (saveAccomplishmentList) {
                        updatedAccomplishment = response.data.accomplishments.map((list) => {
                            const match = saveAccomplishmentList.find((item) => item === list.name);
                            if (match) {
                                return { ...list, disabled: true };
                            }
                            return list;
                        });
                    } else {
                        updatedAccomplishment = response.data.accomplishments;
                    }

                    setLoader(false);
                    setAccomplishmentList(updatedAccomplishment);
                    setError('');
                }
            } catch (error) {
                setError(error.message);
                setLoader(false);
            }
        })()

    }, [searchInput, searchToggle]);

    /** call API to fetch the Accomplishment data end */

    const handleAccomplishmentListClick = (itemName) => {
        const accomplishmentListCopy = [...accomplishmentList];
        const appendAccomplishment = accomplishmentEditorItem ? accomplishmentEditorItem + '<p>' + itemName + '</p>' : '<p>' + itemName + '</p>';
        setAccomplishmentEditorItem(appendAccomplishment);
        setAccomplishmentValidation('');
        accomplishmentListCopy.forEach(item => {
            if (accomplishmentEditorItem.includes(item.name)) {
                item.disabled = true;
            }
        });
        setAccomplishmentList(accomplishmentListCopy);
        setSuccess('')
    }

    const handleEditorDataChange = (event, editor) => {
        const content = editor.getData();
        const strippedData = content.replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/&nbsp;/g, ' ');
        
        const matchSkillsList = accomplishmentList.map(dataItem =>
            strippedData.includes(dataItem.name) ? { ...dataItem, disabled: true } : { ...dataItem, disabled: false }
        );

        setAccomplishmentEditorItem(content);
        setAccomplishmentList(matchSkillsList);
        setSuccess('')
    }
    
    const accomplishmentsEditor = {
        ui: {
            poweredBy: {
                forceVisible: false
            }
        },
        toolbar: [
            'bold',
            'italic',
        ],
        toolarLocation: 'bottom',
        placeholder: 'Enter your accomplishments'
    };

    const closePopUp = () => {
        setSuccess('')
        setError('')
        setAccomplishmentValidation('')
    };

    return (
        <>
            <Modal
                {...props}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop='static'
            >
                <Modal.Header closeButton onClick={closePopUp}>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Accomplishments
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={6} className='mb-3'>
                            <Col md={12} className='skill-left-section'>
                                <h6 className='text-center mt-2'>Search By Job Title For Pre-Written Examples</h6>
                                <Col md={12} className='ai-search-skill-form'>
                                    <Form onSubmit={handleAccomplishmentSearch}>
                                        <div className='ai-serach-form-section'>
                                            <div className='input-section'>
                                                <Form.Control
                                                    placeholder="Search By Job Title"
                                                    size="lg"
                                                    type='text'
                                                    id="searchAccomplishment"
                                                />
                                            </div>
                                            <div className='button-section'>
                                                <button type="submit" className="search-skill-btn"><i className="fa fa-search"></i></button>
                                            </div>
                                        </div>
                                    </Form>
                                    {
                                        error ?
                                            <Col md={12} className='mt-3 d-inline-block w-100'>
                                                <div className="alert alert-danger" role="alert">
                                                    {error}
                                                </div>
                                            </Col> : ''
                                    }
                                </Col>
                                <Col md={12} className='mt-3 ai-search-skill-result-part'>
                                    <Card>
                                        <Card.Body>
                                            <Card.Title>Ready-to-use-examples</Card.Title>
                                            <div className='ai-list-item'>

                                                <ul>

                                                    {

                                                        loader === true ? <SpinLoader /> :
                                                            accomplishmentList?.map((item, index) => (
                                                                <li key={item.id} item={item.name} >
                                                                    <div className='button-part'>
                                                                        <Button onClick={() => handleAccomplishmentListClick(item.name, index)} disabled={item.disabled}>
                                                                            <i className="fa fa-plus" aria-hidden="true"></i>
                                                                        </Button>
                                                                    </div>
                                                                    <div className='text-part source-editor-1'>
                                                                        <p>{item.name}</p>
                                                                    </div>
                                                                </li>
                                                            ))

                                                    }

                                                </ul>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Col>
                        </Col>
                        <Col md={6} className='mb-3'>
                            <Col md={12} className='skill-right-section responsive-right-section'>

                                <h4 className='mb-3 fw-bold'>Tell us about your accomplishments</h4>

                                <div className='skill-right-content-part'>
                                    <div className='summary-editor '>
                                        <CKEditor
                                            editor={ClassicEditor}
                                            data={accomplishmentEditorItem}
                                            config={accomplishmentsEditor}
                                            onChange={handleEditorDataChange}
                                        />
                                    </div>
                                </div>
                                {
                                    accomplishmentValidation ? <div className="alert alert-danger mt-3" role="alert">{accomplishmentValidation}</div> : ''
                                }
                                {
                                    success !== '' ? <div className="alert alert-success mt-3" role="alert">{success}</div> : ''
                                }
                            </Col>
                        </Col>
                        <Modal.Footer>
                            <Button className='button-green' type="submit" onClick={saveAccomplishment}>Save changes</Button>
                        </Modal.Footer>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default AccomplishmentsModal
